export type PromoCodeType = 'SINGLE_USE' | 'SINGLE_USE_GLOBAL' | 'MULTI_USE';

export const promoCodeTypeLabels: Record<PromoCodeType, string> = {
  SINGLE_USE: 'Single Use',
  SINGLE_USE_GLOBAL: 'Single Use (Global)',
  MULTI_USE: 'Multi Use',
};

export type ProductType = 'TICKETED_EVENT';

export const productTypeLabels: Record<ProductType, string> = {
  TICKETED_EVENT: 'Ticketed Events',
};

export type DiscountType = 'PERCENTAGE' | 'FLATAMOUNT' | 'PRICEOVERRIDE';

export interface PromoCodeTicketedEvent {
  promoCodeId: string;
  ticketedEventId: string;
  ticketedEvent?: {
    id: string;
    name: string;
    startDateTime?: string | null;
    venue?: { id: string; name: string };
  };
}

export interface PromoCodeStats {
  totalDiscountGiven: number;
  avgDiscountAmount: number;
  redemptionsByStatus: {
    PENDING: number;
    APPLIED: number;
    REVERTED: number;
  };
  redemptionsByProductType: {
    TICKETED_EVENT: number;
    SHOP_PURCHASE: number;
  };
}

export interface PromoCodeMeta {
  stats: PromoCodeStats;
}

export interface PromoCode {
  id: string;
  code: string;
  description?: string | null;
  codeType: PromoCodeType;
  discountType: DiscountType;
  discountValue: number;
  maxRedemptions?: number | null;
  timesRedeemed: number;
  validFrom: string;
  validUntil?: string | null;
  isActive: boolean;
  scope?: ProductType[];
  promoCodeTicketedEvents?: PromoCodeTicketedEvent[];
  meta?: PromoCodeMeta;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreatePromoCodePayload {
  code: string;
  description?: string | null;
  codeType: PromoCodeType;
  discountType: DiscountType;
  discountValue: number;
  maxRedemptions?: number | null;
  validFrom?: string;
  validUntil?: string | null;
  isActive?: boolean;
  scope?: ProductType[];
  ticketedEventIds?: string[];
}

export interface UpdatePromoCodePayload {
  code?: string;
  description?: string | null;
  codeType?: PromoCodeType;
  discountType?: DiscountType;
  discountValue?: number;
  maxRedemptions?: number | null;
  validFrom?: string;
  validUntil?: string | null;
  isActive?: boolean;
  scope?: ProductType[];
  ticketedEventIds?: string[];
}
